module.exports = __webpack_public_path__ + "static/media/08_Mascotte_nuit.caecfa0c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/08_Mascotte_nuit.svg
// module id = 764
// module chunks = 0